import { render, staticRenderFns } from "./printItem.vue?vue&type=template&id=67571fa8&scoped=true&"
import script from "./printItem.vue?vue&type=script&lang=js&"
export * from "./printItem.vue?vue&type=script&lang=js&"
import style0 from "./printItem.vue?vue&type=style&index=0&id=67571fa8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67571fa8",
  null
  
)

export default component.exports